import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout/logout.component';
import { ChangepasswordComponent } from './login/changepassword/changepassword.component';
import { AuthGuard } from './guard/auth.guard';
import { DefaultLayoutComponent } from './containers';

import { CorporateLeadsComponent } from './pages/makers/corporate-leads/corporate-leads.component';
import { CorporateMakerComponent } from './pages/makers/corporate-maker/corporate-maker.component';
import { CorporateCheckerComponent } from './pages/checkers/corporate-checker/corporate-checker.component';
import { AdminMakerComponent } from './pages/makers/admin-maker/admin-maker.component';
import { AdminCheckerComponent } from './pages/checkers/admin-checker/admin-checker.component';
import { ManageCustomerComponent } from './pages/checkers/manage-customer/manage-customer.component';
import { RetailAdminComponent } from './pages/makers/retail-admin/retail-admin.component';
import { SupportAdminComponent } from './pages/makers/support-admin/support-admin.component';
import { SupportComplaintsComponent } from './pages/makers/support-complaints/support-complaints.component';
import { SupportComplaintsUpdateStatusComponent } from './pages/makers/support-complaints/support-complaintsUpdateStatus/support-complaintsUpdateStatus.component';
import { SupportProspectiveCustomersComponent } from './pages/makers/support-prospective-customers/support-prospective-customers.component';
import { SupportHoldQueAuditLogComponent } from './pages/makers/support-hold-que-audit-log/support-hold-que-audit-log.component';
import { SupportUserProfileAuditReportComponent } from './pages/makers/support-user-profile-audit-report/support-user-profile-audit-report.component';
import { SupportUserPermissionAuditReportComponent } from './pages/makers/support-user-permission-audit-report/support-user-permission-audit-report.component';
import { PageNotFoundComponent } from './pages/general/page-not-found/page-not-found.component';
import { OnboardingComponent } from './pages/makers/retail-admin/onboarding/onboarding.component';
import { InvitationsComponent} from './pages/makers/retail-admin/invitations/invitations.component';
import { DecisionTableComponent } from './pages/makers/retail-admin/onboarding/decision-table/decision-table.component';
import { SwiftTransferComponent } from './pages/makers/swift-transfer/swift-transfer.component';
import { InvitationListComponent } from './pages/makers/retail-admin/invitations/invitation-list/invitation-list.component';
import { RetailCustomerListComponent } from './pages/makers/retail-admin/retail-customers/retail-customerList.component';
import { RetailClientClassificationComponent } from './pages/makers/retail-admin/retail-clientClassification/retail-clientClassification.component';


const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login'
    }
  },
  {
    path: 'changepassword',
    component: ChangepasswordComponent,
    data: {
      title: 'Change Password'
    }
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      title: 'Logout'
    }
  },
  {
    path: 'home',
    component: DefaultLayoutComponent,
    data: {
      title: 'Dashboard'
    },
    children: [
      {
        path: 'app-admin-maker',
        component: AdminMakerComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Manage Users',
          role: 1
        }
      },
      {
        path: 'app-admin-checker',
        component: AdminCheckerComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Manage Users',
          role: 7
        }
      },
      {
        path: 'corporate-leads',
        component: CorporateLeadsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Corporate Leads',
          role: 3
        }
      },
      {
        path: 'corporate-maker',
        component: CorporateMakerComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Corporate Maker',
          role: 3
        }
      },
      {
        path: 'corporate-checker',
        component: CorporateCheckerComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Corporate Checker',
          role: 4
        }
      },
      {
        path: 'manage-customer',
        component: ManageCustomerComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Manage Customer',
          role: 4
        }
      },
      {
        path: 'app-retail-admin',
        component: RetailAdminComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Reset Password',
          role: 5
        }
      },
      {
        path: 'app-retail-customers',
        component: RetailCustomerListComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Customers',
          role: 5
        }
      },
      {
        path: 'app-retail-client-classification',
        component: RetailClientClassificationComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Client Classification',
          role: [5,8]
        }
      },
      {
        path: 'app-onboarding',
        component: OnboardingComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Manage Decision Parameters',
          role: 5
        }
      },
      {
        path: 'app-decision-table',
        component: DecisionTableComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Manage Decision Table',
          role: 5
        }
      },
       {
        path: 'app-invitations',
        component: InvitationsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Manage Invitations',
          role: 5
        }
      },
      {
        path: 'app-invitation-list',
        component: InvitationListComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Invitation > Invitation list',
          role: 5
        }
      },
      {
        path: 'app-swift-transfer',
        component: SwiftTransferComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Remittances',
          role: [3,4,5,6]
        }
      },
      {
        path: 'supportadmin',
        component: SupportAdminComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Support Admin > Manage Service Requests',
          role: 6
        }
      },
      {
        path: 'supportcomplaints',
        component: SupportComplaintsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Support Admin > Manage Complaints',
          role: 6
        }
      },
      {
        path: 'prospective-customers',
        component: SupportProspectiveCustomersComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Support Admin > Prospective Customers',
          role: 6
        }
      },
      {
        path: 'supportcomplaints/update-status/:id',
        component: SupportComplaintsUpdateStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Support Admin > Manage Complaints > Update Status',
          role: 6
        }
      },
      {
        path: 'holdqueueauditlog',
        component: SupportHoldQueAuditLogComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Support Admin > Hold Queue Audit Report',
          role: 6
        }
      },
      {
        path: 'userprofilereport',
        component: SupportUserProfileAuditReportComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Support Admin > User Profile Audit Report',
          role: 6
        }
      },
      {
        path: 'userpermissionreport',
        component: SupportUserPermissionAuditReportComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard > Support Admin > User Permissions Audit Report',
          role: 6
        }
      },
    ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Dashboard',
      role: 3
    }
  },
  { 
    path: '**', 
    pathMatch: 'full',  
    component: PageNotFoundComponent 
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
